import axios from "@/api/axiosAuthRequired.js"
import { GAME_KEYS } from "@/store/game/game.constants"
import { INSTAPRO_BASE_URL } from "@/constants/util"
import { paramsSerializer } from "@/utils/api.utils"

const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const fetchInstaPROGames = () => {
  return axios({
    method: "get",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/instapro/games",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getAvailableGames = async ({ page }) => {
  try {
    const url = `${INSTAPRO_BASE_URL}games`
    const config = {
      params: { page },
      paramsSerializer,
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    Promise.reject(error)
  }
}

export const getAllInstaproGames = async () => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/instapro/games`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return []
  }
}

export const GAME_LABELS = {
  [GAME_KEYS.APEX_LEGENDS]: {
    regions: {
      US: "United States",
      BR: "Brazil",
      UK: "United Kingdom",
      NL: "Netherlands",
      BE: "Belgium",
      DE: "Germany",
      HK: "Hong Kong",
      TW: "Taiwan",
      SG: "Singapore",
      JP: "Japan",
      AU: "Australia",
    },
    specializations: {
      defense: "Defense",
      offense: "Offense",
      recon: "Recon",
      support: "Support",
    },
  },
  [GAME_KEYS.BRAWLHALLA]: {
    regions: {
      JP: "Japan",
      USW: "US West",
      USE: "US East",
      BR: "Brazil",
      EU: "Europe",
      SEA: "Southeast Asia",
      AU: "Australia",
    },
    specializations: {},
  },
  [GAME_KEYS.CHESS]: {
    regions: {},
    specializations: {},
  },
  [GAME_KEYS.CLASH_ROYALE]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      deckbuilding: "Deck Building",
      execution: "Gameplay",
    },
  },
  [GAME_KEYS.COD_COLD_WAR]: {
    regions: {
      NA: "North America",
      SA: "South America",
      EU: "Europe",
      RU: "Russia",
      ME: "Middle East",
      AS: "Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.COD_MODERN_WARFARE]: {
    regions: {
      NA: "North America",
      SA: "South America",
      EU: "Europe",
      RU: "Russia",
      ME: "Middle East",
      AS: "Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.COD_VANGUARD]: {
    regions: {
      EU: "Europe",
      NA: "North America",
      USE: "US East",
      USW: "US West",
      AS: "Asia",
      SA: "South Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.COD_WARZONE]: {
    regions: {
      NA: "North America",
      SA: "South America",
      EU: "Europe",
      RU: "Russia",
      ME: "Middle East",
      AS: "Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.CSGO]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      awper: "AWP",
      utility: "Utility",
      communication: "Communication",
    },
  },
  [GAME_KEYS.DESTINY2]: {
    regions: {
      NA: "North America",
      LAS: "Latin America South",
      EU: "Europe",
      RUS: "Russia",
      ME: "Middle East",
      OCE: "Oceania",
    },
    specializations: {
      "warlock": "Warlock",
      "hunter": "Hunter",
      "titan": "Titan",
    },
  },
  [GAME_KEYS.DOTA2]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      carry: "Carry",
      offlane: "Offlane",
      mid: "Mid",
      support: "Support",
    },
  },
  [GAME_KEYS.FIFA]: {
    regions: {
      NA: "North America",
      SA: "South America",
      EUW: "Europe West",
      EUNE: "Europe Nordic and East",
      ASIA: "Asia",
      AFRICA: "Africa",
      OC: "Oceania",
    },
    specializations: {},
  },
  [GAME_KEYS.FORTNITE]: {
    regions: {
      NAE: "North America East",
      NAW: "North America West",
      EU: "Europe",
      OCE: "Oceania",
      ME: "Middle East",
      AS: "Asia",
      BR: "Brazil",
    },
    specializations: {
      building: "Building",
      aiming: "Aiming",
      decision: "Decision Making",
    },
  },
  [GAME_KEYS.HALO_INFINITE]: {
    regions: {
      EU: "Europe",
      NA: "North America",
      USE: "US East",
      USW: "US West",
      AS: "Asia",
      SA: "South Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.HEARTHSTONE]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      aggro: "Aggro",
      combo: "Combo",
      midrange: "Midrange",
      control: "Control",
    },
  },
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: {
    regions: {
      NA: "North America",
      EUW: "Europe West",
      EUNE: "Europe Nordic & East",
      LAN: "Latin America North",
      LAS: "Latin America South",
      BR: "Brazil",
      OCE: "Oceania",
      RU: "Russia",
      TR: "Turkey",
      JP: "Japan",
      SEA: "South East Asia",
      KR: "Korea",
      CN: "China",
      ME: "Middle East",
    },
    specializations: {
      top: "Top",
      ad: "AD Carry",
      support: "Support",
      mid: "Mid",
      jungle: "Jungle",
    },
  },
  [GAME_KEYS.MTG]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      aggro: "Aggro",
      combo: "Combo",
      midrange: "Midrange",
      control: "Control",
    },
  },
  [GAME_KEYS.OVERWATCH]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      dps: "DPS/Damage",
      tank: "Tank",
      support: "Support",
    },
  },
  [GAME_KEYS.PUBG]: {
    regions: {
      NA: "North America",
      SA: "South America",
      EU: "Europe",
      OC: "Oceania",
      RU: "Russia",
      AS: "Asia",
      KR: "Korea",
      SEA: "Southeast Asia",
    },
    specializations: {},
  },
  [GAME_KEYS.RAINBOW_SIX_SIEGE]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      SA: "South America",
      ASIA: "Asia",
      AFRICA: "Africa",
      OCE: "Oceania",
    },
    specializations: {},
  },
  [GAME_KEYS.ROCKET_LEAGUE]: {
    regions: {
      US: "United States",
      BR: "Brazil",
      UK: "United Kingdom",
      NL: "Netherlands",
      BE: "Belgium",
      DE: "Germany",
      HK: "Hong Kong",
      TW: "Taiwan",
      SG: "Singapore",
      JP: "Japan",
      AU: "Australia",
      FR: "France",
      IT: "Italy",
      ZA: "South Africa",
      MED: "Dubai",
      MEM: "Mumbai",
    },
    specializations: {
      "freestyle": "Freestyle",
      "decision-making": "Decision Making",
      "dribbling": "Dribbling",
      "airplay": "Airplay",
      "defense": "Defense",
    },
  },
  [GAME_KEYS.SMITE]: {
    regions: {
      NA: "North America",
      SA: "South America",
      LAN: "Latin America North",
      EU: "Europe",
      OCE: "Oceania",
      SEA: "Southeast Asia",
      KR: "Korea",
    },
    specializations: {},
  },
  [GAME_KEYS.SSBU]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      heavy: "Heavies",
      sword: "Swordies",
      projectile: "Projectile",
      rushdown: "Rush Down",
    },
  },
  [GAME_KEYS.TEAMFIGHT_TACTICS]: {
    regions: {
      NA: "North America",
      EUW: "Europe West",
      EUNE: "Europe Nordic & East",
      LAN: "Latin America North",
      LAS: "Latin America South",
      BR: "Brazil",
      OCE: "Oceania",
      RU: "Russia",
      TR: "Turkey",
      JP: "Japan",
      SEA: "South East Asia",
      KR: "Korea",
      CN: "China",
    },
    specializations: {},
  },
  [GAME_KEYS.VALORANT]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      LATAM: "Latin America",
      KR: "Korea",
    },
    specializations: {},
  },
  [GAME_KEYS.WILD_RIFT]: {
    regions: {
      ID: "Indonesia",
      JP: "Japan",
      MY: "Malaysia",
      PH: "Philippines",
      SG: "Singapore",
      KR: "Korea",
      TH: "Thailand",
      EU: "Europe",
      ME: "Middle East",
      MENA: "North Africa",
      OCE: "Oceania",
      RU: "Russia",
      TW: "Taiwan",
      TR: "Turkey",
      VN: "Vietnam",
    },
    specializations: {},
  },
  [GAME_KEYS.WOW]: {
    regions: {
      NA: "North America",
      EU: "Europe",
      BR: "Brazil",
      JP: "Japan",
      OCE: "Oceania",
      KR: "Korea",
    },
    specializations: {
      raiding: "Raiding",
      pvp: "PvP",
      leveling: "Leveling",
      warrior: "Warrior",
      paladin: "Paladin",
      hunter: "Hunter",
      rogue: "Rogue",
      priest: "Priest",
      death_knight: "Death Knight",
      shaman: "Shaman",
      mage: "Mage",
      warlock: "Warlock",
      monk: "Monk",
      druid: "Druid",
      demon_hunter: "Demon Hunter",
    },
  },
}



// WEBPACK FOOTER //
// ./src/api/services/instapro.js